export default function () {
  return new Promise((resolve, reject) => {
    const filtratedLineItems = theme.cart.items.filter(
        (item) => item.sku.substring(0, 6).length >= 6
    );

    let total_price = 0;

    resolve({
      Name: "default",
      LineItems: filtratedLineItems.map((item) => {
        total_price += item.final_line_price;

        return {
          Product: {
            Id: item.sku.substring(0, 6),
          },
          Variant: {
            Id: item.sku,
          },
          Quantity: item.quantity,
          LineTotal: parseFloat(String(item.final_line_price / 100)),
        };
      }),
      Subtotal: {
        Amount: parseFloat(String(total_price / 100)),
        Currency: {
          value: theme.cart.currency,
        },
      },
    });
  });
}
